import { render, staticRenderFns } from "./completeRegistration.vue?vue&type=template&id=77d157bf&scoped=true&"
import script from "./completeRegistration.vue?vue&type=script&lang=ts&"
export * from "./completeRegistration.vue?vue&type=script&lang=ts&"
import style0 from "./completeRegistration.vue?vue&type=style&index=0&id=77d157bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d157bf",
  null
  
)

export default component.exports